// extracted by mini-css-extract-plugin
module.exports = {"content":"customer-account-claims-confirmation-modal_content__3WYlF"};